'use client';

import { Box, Tooltip } from '@mui/material';
import type { IngestionPipelineStatus } from '@repo/api-gw-sdk';
import React from 'react';

interface IngestionPipelineStatusConfig {
  title: string;
  iconColor: string;
  backgroundColor: string;
  icon: string;
}

const ingestionPipelineStatusConfig: Record<
  string,
  IngestionPipelineStatusConfig
> = {
  ENABLED: {
    title: 'Enabled',
    iconColor: 'var(--mui-palette-success-main)',
    backgroundColor: 'var(--mui-palette-success-opacity)',
    icon: 'material-symbols-check-circle-outline-rounded',
  },
  DISABLED: {
    title: 'Disabled',
    iconColor: 'var(--mui-palette-custom-GREY-01)',
    backgroundColor: 'var(--mui-palette-custom-GREY-OPACITY)',
    icon: 'material-symbols-do-not-disturb-on-outline-rounded',
  },
};

export const IngestionPipelineStatusCell = React.forwardRef<
  HTMLSpanElement,
  {
    status: IngestionPipelineStatus;
    hideTooltip?: boolean;
  }
>(({ status, hideTooltip }, ref) => {
  const config = ingestionPipelineStatusConfig[status];
  if (!config) {
    return null;
  }

  return (
    <Tooltip title={hideTooltip ? undefined : config.title}>
      <Box
        ref={ref}
        component='span'
        className='rounded-full inline-flex p-[2px]'
        sx={{
          background: config.backgroundColor,
          '& i': {
            background: config.iconColor,
          },
        }}
      >
        <i className={`${config.icon} h-[20px] w-[20px]`} />
      </Box>
    </Tooltip>
  );
});

IngestionPipelineStatusCell.displayName = 'IngestionPipelineStatusCell';
